export default async function ({
                                 store,
                                 params,
                                 app,
                                 error
                               }) {
  await store.dispatch('pages/organization/agency', {
    id: params.id,
    params: {
      resolution: 'micro',
      lang: app.i18n.locale
    }
  })
    .then(() => {
      const agency = store.getters['pages/organization/agency']
      if (!(agency && agency?.status === 'active')) {
        error({statusCode: 404})
      }
    })
}
